export enum TestamentaryEntityTabs {
  Summary = 'SUMMARY',
  AccessAfterDeath = 'ACCESS_AFTER_DEATH',
  AccessAfterBothDeaths = 'ACCESS_AFTER_BOTH_DEATHS',
  Trustees = 'TRUSTEES',
  Disposition = 'DISPOSITION',
}
